import { Injectable } from "@angular/core";
import { JQueryHTTPClient } from "../../../../rest/JQueryHTTPClient";
import { EntityService } from "../../../../rest/entity.service";
import { Rest } from "../../../../rest/rest_client";



@Injectable()
export class WorkshopService extends EntityService<Rest.InvWorkshop> {
    client: Rest.RestApplicationClient;

    constructor(private jquery: JQueryHTTPClient) {
        super();
        this.client = new Rest.RestApplicationClient(jquery);
    }

    create(arg0: Rest.InvWorkshop): Rest.RestResponse<Rest.InvWorkshop> {
        try {
            return this.client.Workshop_create(arg0);
        } catch (error) {
            console.error("Error creating Workshop:", error);
            throw error;
        }
    }

    update(arg0: Rest.InvWorkshop): Rest.RestResponse<Rest.InvWorkshop> {
        try {
            return this.client.Workshop_update(arg0);
        } catch (error) {
            console.error("Error updating Workshop:", error);
            throw error;
        }
    }

    getPage(
        arg0: Rest.ListPaginationRequest,
        queryParams?: { includeDisabled?: boolean }
    ): Rest.RestResponse<Rest.Page<Rest.InvWorkshop>> {
        try {
            return this.client.Workshop_getPage(arg0, queryParams);
        } catch (error) {
            console.error("Error getting page:", error);
            throw error;
        }
    }

    changeStatus(
        arg0: number[],
        queryParams?: { status?: boolean }
    ): Rest.RestResponse<void> {
        try {
            return this.client.Workshop_changeStatus(arg0, queryParams);
        } catch (error) {
            console.error("Error changing status:", error);
            throw error;
        }
    }

    // @ts-ignore
    find(
        arg0: string,
        queryParams?: { id?: number }
    ): Rest.RestResponse<Rest.InvWorkshop> {
        try {
            return this.client.Workshop_find(arg0, queryParams);
        } catch (error) {
            console.error("Error finding AlarmType:", error);
            throw error;
        }
    }
}